import React from "react";
import CountUp from "react-countup";

// image
import Ab1 from "../../images/about.jpg";
import Abd1 from "../../images/doctors/1.jpg";
import Abd2 from "../../images/doctors/2.jpg";
import Abd3 from "../../images/doctors/3.jpg";
import Abd4 from "../../images/doctors/4.jpg";
import sine from "../../images/signeture.png";

const about = (props) => {
  return (
    <section className={"" + props.hclass}>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 col-12">
            <div className="about_left">
              <div className="image">
                <img src={Ab1} alt="" />
                <span className="round-on"></span>
                <span className="round-two"></span>
                <div className="award">
                  <div className="icon">
                    <i className="flaticon-cup"></i>
                  </div>
                  <div className="text">
                    <h2>
                      <CountUp end={5} enableScrollSpy />+
                    </h2>
                    <p>Years Of Experience</p>
                  </div>
                </div>
                <div className="doctors">
                  <ul>
                    <li>
                      <img src={Abd1} alt="" />
                    </li>
                    <li>
                      <img src={Abd2} alt="" />
                    </li>
                    <li>
                      <img src={Abd3} alt="" />
                    </li>
                    <li>
                      <img src={Abd4} alt="" />
                    </li>
                    <li>
                      <span>140+</span>
                    </li>
                  </ul>
                  <h4>Available Products</h4>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-12">
            <div className="content">
              <h2>About Tebii lifecare</h2>
              <h3>Because we Care!</h3>
              <p>
                Tebii lifecare is Kolhapur based pharmaceutical company that
                deal in pharma manufacturing & PCD Pharma Franchise Business.
              </p>
              <p>
                We are leading manufacturers and marketers of Pharmaceutical
                formulations and recognized in the market, due to our ability to
                manufacture, export and supply a diverse and qualitative range
                of Injectable, Capsules, Tablets, Softgel Capsules, Dry Syrup,
                Syrup, Facewash, Ointments, Eye Drops, Lotion, Ear Drops, Oral
                Liquid (Syrup & Suspension), External Liquids, Creams,
                Betalactum Products, General Products ,Nutraceuticals, Soaps,
                Shampoo, Oral Sachets & Powders Tebii lifecare is rapidly
                growing pharmaceutical formulations manufacturing, marketing,
                and export oriented company.
              </p>
              <p>
                Manufacturing and marketing of quality pharmaceutical
                formulations affordable to the Indian masses and having global
                quality is our motto it. has expanded its reach to virtually
                every corner of India by continuously adding new distributors
                and agents all over the nation for its pharmaceutical
                formulations.
              </p>
              <p>
                Still, it is a constant Endeavour of Tebii Lifecare Pvt Ltd to
                spread itself at the unrepresented areas through appointment of
                new distributors. spread their business at the unrepresented
                areas through appointment of new franchise/distributors / sole
                distributors / PCD franchise on the monopoly basis. So Tebii
                Lifecare is top PCD pharma franchise company in Kokhapur which
                has built trusted customer relationships based on
                integrity,reliability & exceptional service
              </p>
              <div className="ceo">
                <div>
                  <h4>Sachin Taukari</h4>
                  {/* <span>CEO & Founder of Tebii lifecare</span> */}
                </div>
                {/* <div>
                  <img src={sine} alt="" />
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default about;
